/**
 * Created by mnaughton on 10/16/2015.
 */

import BaseFieldView from "core/views/Field/BaseFieldView";
var TRUE = "Yes",
  FALSE = "No";

export default BaseFieldView.extend({
  tagName: "span",

  template: function (options) {
    return options.value ? TRUE : FALSE;
  },

  getControlValue: function () {
    return this.$el.html() == TRUE;
  },

  setControlValue: function (value) {
    this.$el.html(value ? TRUE : FALSE);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/view/CheckBoxView.js
// module id = 846
// module chunks = 1